const EFFECT_RENDERER_REGISTRY = new Map();

/**
 * Register a component to render effects for a specific resource type.
 * @param {string} resourceType - The resource type (e.g., 'workout_plan').
 * @param {React.ComponentType} component - The component to render. Receives { event } as props.
 */
export const registerEffectRenderer = (resourceType, component) => {
  if (resourceType && component) {
    EFFECT_RENDERER_REGISTRY.set(resourceType, component);
  }
};

/**
 * Get the renderer for a resource type.
 * @param {string} resourceType
 * @returns {React.ComponentType|null}
 */
export const getEffectRenderer = (resourceType) => {
  return EFFECT_RENDERER_REGISTRY.get(resourceType) || null;
};